const WIDGET_CUSTOMIZATION = {
  // Menu
  WIDGET_TAB_LANDING: 'صفحه فرود',
  WIDGET_TAB_CUSTOMIZATION: 'شخصی سازی',
  WIDGET_TAB_DISPLAY: 'تنطیمات نمایش',
  WIDGET_TAB_POSITION: 'موقعیت',

  // description
  WIDGET_CUSTOMIZATION_DESC:
    'ظاهر ابزارکتان را مطابق با هویت بصری برندتان طراحی کنید.',

  //Landing
  WIDGET_LANDING_LANGUAGE_SELECT_ENGLISH: 'انگلیسی',
  WIDGET_LANDING_LANGUAGE_SELECT_PERSIAN: 'فارسی',
  WIDGET_LANDING_LANGUAGE_TITLE: 'زبان ابزارک',
  WIDGET_LANDING_LANGUAGE_DESC: 'نمایش ابزارک به زبان',
  WIDGET_LANDING_TITLE_TITLE: 'عنوان',
  WIDGET_LANDING_TITLE_DESC: 'متنی که در ابزارک گفتگو نمایش داده می‌شود .',
  WIDGET_LANDING_TITLE_PLACEHOLDER: 'متن خوش آمد گویی را وارد کنید .',
  WIDGET_LANDING_TITLE_FA: 'فارسی (پیش فرض)',
  WIDGET_LANDING_TITLE_EN: 'انگلیسی',
  WIDGET_LANDING_LANG_SELECT_TITLE: 'انتخاب زبان',
  WIDGET_LANDING_TEAM_TITLE: 'معرفی تیم',
  WIDGET_LANDING_TEAM_DESC:
    'تیم خود را معرفی کنید بگویید چطور میتوانید به مشتری کمک بکنید .',
  WIDGET_LANDING_TEAM_DESC_PLACEHOLDER: 'متن معرفی را وارد کنید .',
  WIDGET_LANDING_CONV_TITLE: ' شروع مکالمه',
  WIDGET_LANDING_CONV_INPUT_TITLE: 'متن',
  WIDGET_LANDING_CONV_INPUT_PLACEHOLDER: 'متن شروع مکالمه را وارد کنید .',
  WIDGET_LANDING_START_MSG_TITLE: ' توضیحات ',
  WIDGET_LANDING_START_MSG_DESC: 'توضیحات شروع مکالمه را وارد کنید .',

  // Customization
  WIDGET_LOGO_UPLOAD_TITLE: 'لوگو',
  WIDGET_LOGO_UPLOAD_SUBTITLE: 'ابعاد پیشنهادی: 60x60 پیکسل، فرمت PNG.',
  WIDGET_LOGO_UPLOAD_BTN: 'بارگذاری لوگوی اختصاصی',
  WIDGET_LOGO_UPLOAD_REMOVE: 'حذف تصویر',
  WIDGET_LOGO_DEFAULT_TITLE: 'لوگوهای پیش فرض',
  WIDGET_LOGO_BG_COLOR: 'رنگ پس زمینه',
  WIDGET_LOGO_WIDGET_BG_COLOR_DESC:
    'انتخاب رنگ برای پس‌زمینه سرصفحه‌ها و صفحه فرود.',
  WIDGET_LOGO_BG_COLOR_TITLE: 'رنگ پس زمینه لوگو',
  WIDGET_LOGO_BG_COLOR_DESC:
    'تعیین رنگ پس‌زمینه برای لوگوی ابزارک و صفحه فرود.',
  WIDGET_LOGO_SECONDARY_COLOR_TITLE: 'رنگ مکمل',
  WIDGET_HEADER_TITLE_COLOR_TITLE: 'رنگ تیترها',
  WIDGET_HEADER_TITLE_COLOR_DESC: 'رنگ تیتر هدر و لندینگ',
  WIDGET_LOGO_SECONDARY_COLOR_DESC: 'انتخاب رنگ برای دکمه‌ها و نقاط کلیدی.',
  WIDGET_LOGO_BG_PATTERN_TITLE: 'طرح پس‌زمینه',
  WIDGET_LOGO_BG_PATTERN_DESC: 'تنظیم طرح پس‌زمینه.',
  WIDGET_LOGO_DESCRIPTION: 'امکان بارگذاری لوگوی سفارشی شما.',
  WIDGET_LOGO_DEFAULT_DESC: 'انتخاب از میان لوگوهای آماده.',

  // Display
  WIDGET_DISPLAY_TITLE: 'تنظیم نمایش ابزارک',
  WIDGET_DISPLAY_VACATION_SWITCH_LABEL: 'حالت تعطیلات',
  WIDGET_DISPLAY_VACATION_SWITCH_SUBTEXT: '(فعال‌سازی: عدم نمایش ابزارک)',
  WIDGET_DISPLAY_VACATION_NOTE:
    'توجه: وارد کردن پروتکل (http یا https) در آدرس صفحات ضروری است.',
  WIDGET_DISPLAY_PAGES_TO_DISPLAY_TITLE: 'نمایش ابزارک فقط در این صفحات',
  WIDGET_DISPLAY_PAGES_TO_DISPLAY_PLACEHOLDER:
    'لطفاً آدرس صفحه را وارد کنید. مثال: https://example.com',
  WIDGET_DISPLAY_PAGES_NOT_TO_DISPLAY_TITLE: 'عدم نمایش ابزارک در این صفحات',
  WIDGET_DISPLAY_PAGES_NOT_TO_DISPLAY_PLACEHOLDER:
    'لطفاً آدرس صفحه را وارد کنید. مثال: https://example.com ',
  WIDGET_DISPLAY_PAGES_LINK_ADD_BTN: 'افزودن',

  // Position
  WIDGET_POSITION_DIR_TITLE: 'جهت وب سایت شما',
  WIDGET_POSITION_DIR_SELECT_TITLE: 'انتخاب جهت ',
  WIDGET_POSITION_TITLE: 'موقعیت ابزارک گفتگو',
  WIDGET_POSITION_SELECT_TITLE: 'انتخاب موقعیت ابزارک گفتگو',
  WIDGET_POSITION_PIXEL: 'پیکسل',
  WIDGET_POSITION_MOBILE_LABEL: 'نمایش ابزارک در موبایل',

  WIDGET_POSITION_TOP_LEFT: 'بالا چپ',
  WIDGET_POSITION_TOP_RIGHT: 'بالا راست',
  WIDGET_POSITION_BOTTOM_LEFT: 'پایین چپ',
  WIDGET_POSITION_BOTTOM_RIGHT: 'پایین راست',

  WIDGET_POSITION_DIR_RTL: 'راست به چپ (پیش فرض)',
  WIDGET_POSITION_DIR_LTR: 'چپ به راست',
  WIDGET_OFFSET_MAX_ERROR: 'بیشتر از #value# پیکسل مجاز نیست!',
  WIDGET_LESS_THAN_0_PX_ERROR: 'کمتر از 0 پیکسل مجاز نیست!',

  VALID_DOMAINS: 'دامنه های مجاز',
  VALID_DOMAINS_SUBTEXT: `
  ابزارک رایچت فقط در دامنه و زیردامنه های زیر نمایش می‌دهد. در صورت
  خالی بودن در هیچ دامنه‌ای نمایش نمی‌دهد.
  `,

  // Preview
  WIDGET_PREVIEW_TAB_LANDING: 'صفحه فرود',
  WIDGET_PREVIEW_TAB_CHAT: 'صفحه چت',
};

export default WIDGET_CUSTOMIZATION;
